import { render, staticRenderFns } from "./Productpage.vue?vue&type=template&id=216c3c5f&scoped=true&"
import script from "./Productpage.vue?vue&type=script&lang=js&"
export * from "./Productpage.vue?vue&type=script&lang=js&"
import style0 from "./Productpage.vue?vue&type=style&index=0&id=216c3c5f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216c3c5f",
  null
  
)

export default component.exports